const rooms = {
  props: {
    roomsSelector: "rooms-JS",
    cssSelector: "c-fastbooking__submenu-rooms",
    classNameOutline: " mod--outline",
    classNameFielset: " c-fieldset",
    itemSelector: "c-fastbooking__submenu-rooms-room",
    inputAgeJS: "input-age-JS",
    adultsSelector: "adults-JS",
    childrenSelector: "children-JS",
    teenagerSelector: "teenager-JS",
    childrenAgeSelector: "children-age-JS",
    childAgeSelector: "child-age-JS",
    teenAgeSelector: "teenager-age-JS",
    roomNumberSelector: "room-number-JS",
    adultsNumberSelector: "adults-number-JS",
    childrenNumberSelector: "children-number-JS",
    childAgeNumberSelector: "child-age-number-JS",
    maxAgeChildSelector: "max-age-child-JS",
    maxAgeChildSelectorIcoInfo: "max-age-child-info-icon-JS",
    maxAgeChildSelectorAdultPriceInfo: "max-age-child-info-adult-price-JS",
    maxAgeChildSelectorTeenagerPriceInfo: "max-age-child-info-teenager-price-JS",
    minAgeTeenagerSelector: "min-age-teenager-JS",
    maxAgeTeenagerSelector: "max-age-teenager-JS",
    minAgeTeenagerSelectorIcoInfo: "min-age-teenager-info-icon-JS",
    roomsCountSelector: "rooms-count-JS",
    childAgeId: "child-age-number",
    inputChildSelector: "input-child-JS",
    inputTeenagerSelector: "input-teenager-JS",
    inputAdultSelector: "input-adult-JS",
    inputSelector: "input-JS",
    decButtonSelector: "dec-button-JS",
    incButtonSelector: "inc-button-JS",
    buttonHiddenClassName: "mod--btn-disabled",
    hiddenChildrenClass: "hiddenChildren",
    hiddenTeenagersClass: "hiddenTeenagers",
    addSelector: "add-JS",
    removeSelector: "remove-JS",
    resetSelector: "reset-JS",
    applySelector: "apply-JS",
    cookieName: "barcelo_FB_rooms",
    cfastbookingSubmenuRoomsRoomRoomNumberJS: "c-fastbooking__submenu-rooms-room .room-number-JS",
    template: null,
    templateChildAge: null,
    templateTeenAge: null,
    used: true,
    maxAgeChildDefault: null,
    maxAgeChildUsed: null,
    maxAgeTeenUsed: null,
    valueAgeChildDefault: null,
    valueAgeChildUsed: null,
    minAgeTeenagersUsed: null,
    defaultOccupancy: 11,
    wrongAgeClass: "mod--invalidate",
    defaultAdults: 2,
    defaultMinAdults: 1,
    totalAdults: 0,
    totalChildren: 0,
    incrementButtonChild: "inc-button-child-JS",
    incrementButtonTeenager: "inc-button-teenager-JS",
    messageChildrenAge: "message-children-age-JS",
    data: {
      rooms: 1,
      adults: [2],
      children: [],
    },
  },

  init: function () {
    if (bcl.c.fastbooking.disabled) {
      delete bcl.c.fastbooking.rooms;
      return;
    }

    const $container = bcl.c.fastbooking.commonProps.fastbooking.$container.getElementsByClassName(this.props.cssSelector);

    if (!$container?.[0]) {
      return;
    }

    this.props.$container = $container[0];

    this.props.$rooms = this.searchNode(bcl.c.fastbooking.commonProps.fastbooking.$container, "roomsSelector");
    const $item = this.copyHTML(),
      $remove = this.searchNode($item, "removeSelector");

    $remove?.parentNode?.removeChild($remove);

    this.initItem($item);

    this.initPag();

    this.props.$add = this.initAction({
      $parent: this.props.$container,
      selector: "addSelector",
      callback: this.addItem.bind(this),
    });

    this.initAction({
      $parent: this.props.$container,
      selector: "applySelector",
      callback: this.apply.bind(this),
    });

    this.getInitCookies();
    const incButtons = document.querySelectorAll("." + this.props.incrementButtonChild);
    const message = document.querySelector(".message-children-age-JS");

    incButtons?.forEach((incButton) => {
      incButton.addEventListener("click", function () {
        if (message) {
          message.classList.remove("hidden");
        }
      });
    });
    const closeRibbon = message?.querySelector(".c-ribbon__close-btn");
    closeRibbon?.addEventListener("click", function () {
      if (message) {
        message.classList.add("hidden");
      }
    });
  },

  copyHTML() {
    const $item = this.searchNode(null, "itemSelector");
    if (!$item) {
      return null;
    }

    const $childrenAge = this.searchNode($item, "childrenAgeSelector");
    const $input = $childrenAge?.querySelector("select");

    if ($input) {
      this.props.maxAgeChildDefault = $input.getAttribute("data-max") ?? "";
      this.props.maxAgeChildUsed = $input.getAttribute("max") ?? "";
    }
    if (!this.props.templateChildAge || this.props.templateChildAge.trim() === "") {
      this.props.templateChildAge = this.searchNode($item, "childAgeSelector")?.outerHTML ?? "";
    }
    if (!this.props.templateTeenAge || this.props.templateTeenAge.trim() === "") {
      this.props.templateTeenAge = this.searchNode($item, "teenAgeSelector")?.outerHTML ?? "";
    }

    if ($childrenAge?.children[0]) {
      $childrenAge.children[0].innerHTML = "";
    }

    this.props.template = this.props.$container?.children[0]?.innerHTML ?? "";

    return $item;
  },

  initItem: function ($item) {
    this.initAction({
      $parent: $item,
      selector: "resetSelector",
      callback: this.resetItem.bind(this),
    });

    this.initAction({
      $parent: $item,
      selector: "removeSelector",
      callback: this.removeItem.bind(this),
    });

    this.initInput($item, "adultsSelector", "adultsNumberSelector");
    this.initInput($item, "childrenSelector", "childrenNumberSelector");
    this.initInput($item, "teenagerSelector", "childrenNumberSelector");
  },

  cleanRooms: function () {
    if (!this.props.$container) {
      return;
    }

    const rooms = this.props.$container.getElementsByClassName("c-fastbooking__submenu-rooms-room");

    for (let i = rooms.length; i > 0; i--) {
      const $room = rooms[i - 1];
      const $remove = $room.getElementsByClassName(this.props.removeSelector);
      if ($remove.length > 0) {
        bcl.u.triggerEvent($remove[0], "click");
      } else {
        const $restore = $room.getElementsByClassName(this.props.resetSelector);
        if ($restore.length > 0) {
          bcl.u.triggerEvent($restore[0], "click");
        }
      }
    }

    bcl.cookie.remove(this.props.cookieName);
  },

  initInput: function ($item, selector, numberSelector) {
    const $node = this.searchNode($item, selector),
      $input = this.searchNode($node, "inputSelector"),
      $number = this.searchNode($item, numberSelector); //
    $input.setAttribute("data-default", $input.getAttribute("value"));
    bcl.c.fastbooking.commonProps.rooms["$" + numberSelector] = $input;

    const updateRooms = bcl.u.debounce(
      () => {
        bcl.c.fastbooking.updateFBDynamically();
      },
      500,
      null,
    );
    //To avoid "change" event when selecting the FB for tealeaf analytics
    $input.addEventListener("changeGuests", (e) => {
      $input.setAttribute("value", e.target.value);
      this.changeValueInput($input, $number, $item);
      this.apply(null, null, true);
      updateRooms();
    });

    $input.addEventListener("change", (e) => {
      $input.setAttribute("value", e.target.value);
      this.changeValueInput($input, $number, $item);
      this.apply(null, null, true);
      updateRooms();
    });

    this.initAction({
      $parent: $node,
      selector: "decButtonSelector",
      callback: this.decInput.bind(this),
      argsCallback: {
        $input: $input,
      },
    });

    this.initAction({
      $parent: $node,
      selector: "incButtonSelector",
      callback: this.incInput.bind(this),
      argsCallback: {
        $input: $input,
      },
    });
  },

  initPag: function () {
    const $pagCount = this.searchNode(null, "roomsCountSelector");

    if (!$pagCount) {
      return;
    }

    this.props.$pagCount = $pagCount;

    const total = this.props.$pagCount.parentNode.children[2].innerText;
    this.props.pagTotal = parseInt(total);
  },

  searchNode($parent, selector) {
    selector = this.props[selector] ?? selector;
    $parent = $parent ?? this.props.$container;

    if (!$parent) {
      const $container = bcl.c.fastbooking.commonProps.fastbooking.$container.querySelector(`.${this.props.cssSelector}`);
      if (!$container) {
        return null;
      }

      this.props.$container = $container;
      $parent = this.props.$container;
    }

    const $node = $parent.querySelector(`.${selector}`);
    return $node ?? null;
  },

  initAction: function (obj) {
    const $node = this.searchNode(obj.$parent, obj.selector);

    if (!$node) {
      return;
    }

    if (!obj.argsCallback) {
      obj.argsCallback = {
        $node: $node,
      };
    } else {
      obj.argsCallback.$node = $node;
    }

    const eventType = "click";
    $node.addEventListener("keydown", (e) => {
      if (e.keyCode == 13 || e.keyCode == 32) {
        e.preventDefault();
        $node.click();
      }
    });
    $node.addEventListener(eventType, (e) => {
      if (this.isClickedAcceptButton(e) || this.isClickedAddNewRoom(e)) {
        if (!this.validateChildsSelects()) {
          return;
        }
      }
      if (this.isResetButton(e)) {
        this.showHideMessageAddAgeChild(e.currentTarget, false);
      }
      obj.callback(obj.$parent, obj.argsCallback);
      this.apply(null, null, true);
    });

    return $node;
  },

  isClickedAcceptButton: function (e) {
    return bcl.u.containsClass(e.target.parentElement, "apply-JS");
  },

  isClickedAddNewRoom: function (e) {
    return bcl.u.containsClass(e.target, "add-JS");
  },

  isResetButton: function (e) {
    return bcl.u.containsClass(e.target, "reset-JS");
  },

  validateChildsSelects: function () {
    return this.checkIfChildAgesAreFilled();
  },

  incInput: function ($item, obj) {
    if (this.addChildButtonPressed(obj.$node)) {
      if (!bcl.u.containsClass(obj.$node, this.props.buttonHiddenClassName) && this.checkIfChildAgesAreFilled()) {
        this.incOrDecInput(obj, 1);
      }
    } else {
      this.incOrDecInput(obj, 1);
    }
  },

  decInput: function ($item, obj) {
    if (!bcl.u.containsClass(obj.$node, this.props.buttonHiddenClassName)) {
      this.incOrDecInput(obj, -1);
      this.showHideMessageAddAgeChild(obj.$node, false);
    }
  },

  checkIfChildAgesAreFilled: function () {
    let areFilled = true;
    const childsSelects = document.querySelectorAll(".input-age-JS");
    if (childsSelects && childsSelects.length >= 1) {
      childsSelects.forEach(function (element) {
        if (element.value == "") {
          bcl.u.addClass(element, bcl.c.fastbooking.rooms.props.wrongAgeClass);
          bcl.c.fastbooking.rooms.showHideMessageAddAgeChild(element, true);
          areFilled = false;
        }
      });
    }
    return areFilled;
  },

  showHideMessageAddAgeChild: function (element, show) {
    const msg = bcl.u.closest(element, ".accordion-content");
    if (msg) {
      const targetMsg = msg.querySelector(".add-age-child-msg-JS");
      if (targetMsg) {
        if (show) {
          bcl.u.removeClass(targetMsg, "hidden");
        } else {
          bcl.u.addClass(targetMsg, "hidden");
        }
      }
    }
  },

  incOrDecInput: function (obj, count) {
    const $input = obj.$input,
      value = parseInt($input.getAttribute("value")) + count;
    this.setValueInInput($input, value, true);
  },
  updateAriaLabelBy: function ($input, value) {
    if (!$input) {
      return;
    }
    const $parent = $input.closest(".accordion-item");
    if (!$parent) {
      return;
    }
    const $roomsLabelPax = $parent.querySelector(".js-rooms-label-pax");
    if (bcl.u.containsClass($input, this.props.inputAdultSelector)) {
      const adultCountSpan = $parent.querySelector(".JS-sronly-adultcount");
      if (adultCountSpan) {
        const adultCountText = $roomsLabelPax.dataset.adultsi18n;
        adultCountSpan.innerText = `${adultCountText} ${value}`;
      }
    } else if (bcl.u.containsClass($input, this.props.inputChildSelector)) {
      const childrenCountSpan = $parent.querySelector(".JS-sronly-childrencount");
      if (childrenCountSpan) {
        const childrenCountText = $roomsLabelPax.dataset.childreni18n;
        childrenCountSpan.innerText = ` ,${childrenCountText} ${value}`;
        if (value == 0) {
          childrenCountSpan.setAttribute("aria-hidden", "true");
        } else {
          childrenCountSpan.removeAttribute("aria-hidden");
        }
      }
    }
  },
  changeValueInput: function ($input, $number, $item) {
    const $base = $input.closest(".accordion-item-add-child-JS");
    if (!$base) {
      return;
    }
    const adultValue = parseInt($base.querySelector(".input-adult-JS").value);
    const teenagerValue = parseInt($base.querySelector(".input-teenager-JS").value);
    const childValue = parseInt($base.querySelector(".input-child-JS").value);
    const totalOccupancy = adultValue + teenagerValue + childValue;
    const inputValue = parseInt($input.value);
    let value = inputValue;
    const min = parseInt($input.getAttribute("min")),
      max = parseInt($input.getAttribute("max"));
    if (bcl.u.containsClass($input, this.props.inputChildSelector) || bcl.u.containsClass($input, this.props.inputTeenagerSelector)) {
      value = childValue + teenagerValue;
    }

    let limitTotal = bcl.c.fastbooking.commonProps.destination.data?.data?.guestLimitTotal ? parseInt(bcl.c.fastbooking.commonProps.destination.data.data.guestLimitTotal) : this.props.defaultOccupancy;
    if (limitTotal <= 0) {
      limitTotal = this.props.defaultOccupancy;
    }
    if (min > value) {
      $input.setAttribute("value", min);
      $input.value = min;
      return this.changeValueInput($input, $number, $item);
    }

    if (value > max || !this.checkOccupancy(totalOccupancy, limitTotal)) {
      if (value > max && bcl.s.tooltip) {
        bcl.s.tooltip.props.clickInContainer = true;
        bcl.s.tooltip.click($input.$containerTooltip, $input.$popover);
      }
      $input.setAttribute("value", inputValue - 1);
      $input.value = inputValue - 1;
      return this.changeValueInput($input, $number, $item);
    }

    this.processButtonInput($input, value, min, max, limitTotal);
    this.updateNumber(value, $number);

    if (bcl.u.containsClass($input, this.props.inputChildSelector) || bcl.u.containsClass($input, this.props.inputTeenagerSelector)) {
      this.updateChildrenAge(value, $item, bcl.u.containsClass($input, this.props.inputTeenagerSelector));
    }
  },

  loadOccupancy: function () {
    this.updateValuesMaxMinOccupancy(this.props.$container, "adult");
    this.updateValuesMaxMinOccupancy(this.props.$container, "child");
    this.updateValuesMaxMinOccupancy(this.props.$container, "guest");
    this.updateInfoOccupancy();
  },

  checkOccupancy: function (totalOccupancy, limit) {
    if (totalOccupancy !== -1) {
      return totalOccupancy <= limit;
    }
  },

  updateNumber: function (value, $number) {
    if (value > 0) {
      $number.innerText = value;
      bcl.u.removeClass($number.parentNode, bcl.c.fastbooking.commonProps.fastbooking.hiddenClass);
    } else {
      bcl.u.addClass($number.parentNode, bcl.c.fastbooking.commonProps.fastbooking.hiddenClass);
    }
  },

  createForAllSelects: function ($selectChildAge) {
    const maxAgeChild = $selectChildAge ? parseInt($selectChildAge.dataset.max) : "";
    const minAgeChild = $selectChildAge && $selectChildAge.dataset.min !== undefined ? parseInt($selectChildAge.dataset.min) : 0;
    for (let i = minAgeChild; i <= maxAgeChild; i++) {
      const $option = document.createElement("option");

      $option.value = i;
      $option.innerText = i;
      $selectChildAge.appendChild($option);
    }
  },

  updateChildrenAge: function (value, $item, isTeenager) {
    const $container = this.searchNode($item, "childrenAgeSelector").children[0];

    if (value > 0) {
      const children = isTeenager ? [...$container.querySelectorAll(".teenager-age-JS")] : [...$container.querySelectorAll(".child-age-JS")];
      const template = isTeenager ? this.props.templateTeenAge : this.props.templateChildAge;

      while (children.length > value) {
        $container.removeChild(children.pop());
      }

      for (let n = children.length; n < value; n++) {
        this.addChildAge($container, n, isTeenager, template);
      }

      bcl.u.removeClass($container.parentNode, bcl.c.fastbooking.commonProps.fastbooking.hiddenClass);
    } else {
      bcl.u.addClass($container.parentNode, bcl.c.fastbooking.commonProps.fastbooking.hiddenClass);

      while ($container.firstChild) {
        $container.removeChild($container.firstChild);
      }
    }
  },

  updateChildrenAgeInputs: function () {
    const updateRooms = bcl.u.debounce(
      () => {
        bcl.c.fastbooking.updateFBDynamically();
      },
      500,
      null,
    );

    const inputChildAges = Array.from(document.querySelectorAll("." + this.props.inputAgeJS));
    inputChildAges.forEach((input) => {
      input.addEventListener("change", () => {
        if (bcl.c.hotelRoomList) {
          updateRooms();
        }
      });
    });
  },

  addChildButtonPressed: function ($item) {
    let clickAddChild = false;
    if (bcl.u.containsClass($item, this.props.incrementButtonChild) || bcl.u.containsClass($item, this.props.incrementButtonTeenager)) {
      clickAddChild = true;
    }
    return clickAddChild;
  },

  addChildAge: function ($container, index, isTeenager, template) {
    let $newItem = document.createElement("div");

    if (!template || typeof template !== "string" || template.trim() === "") {
      console.error("Invalid template:", template);
      return;
    }

    $newItem.innerHTML = template;

    if ($newItem.children.length === 0) {
      console.error("Error: $newItem has no children after setting innerHTML.", $newItem.innerHTML);
      return;
    }

    $newItem = $newItem.children[0];

    const count = index + 1,
      id = this.props.childAgeId + "-" + count,
      $numberAge = this.searchNode($newItem, "childAgeNumberSelector");

    if ($newItem.children.length < 2) {
      console.error("Error: Expected at least 2 children in $newItem, found:", $newItem.children.length);
      return;
    }

    $newItem.children[0].setAttribute("for", id);

    const $input = $newItem.children[1];
    $input.setAttribute("id", id);

    this.updateOptionsSelectChildAges($input);

    $input.addEventListener("change", (e) => {
      $input.setAttribute("value", e.target.value);
      $input.value = e.target.value;

      if (this.isAgeChildSelectFilled(e)) {
        this.removeRequiredAgeClass(e.target);
        bcl.c.fastbooking.rooms.showHideMessageAddAgeChild(e.target, false);
      }

      this.apply(null, null, true);
    });

    const typedAgeSelector = isTeenager ? $container.getElementsByClassName(this.props.teenAgeSelector) : $container.getElementsByClassName(this.props.childAgeSelector);

    if ($numberAge) {
      $numberAge.innerText = typedAgeSelector.length + 1;
    } else {
      console.error("Error: childAgeNumberSelector not found in $newItem", $newItem);
    }

    $container.append($newItem);
    this.updateChildrenAgeInputs();
  },

  isAgeChildSelectFilled: function (e) {
    return e.target.value != "";
  },

  removeRequiredAgeClass: function ($element) {
    if (bcl.u.containsClass($element, bcl.c.fastbooking.rooms.props.wrongAgeClass)) {
      bcl.u.removeClass($element, bcl.c.fastbooking.rooms.props.wrongAgeClass);
    }
  },

  updateOptionsSelectChildAges: function ($select, update, index, childAge) {
    $select.addEventListener("change", function () {
      bcl.s.tabs.props.clickInContainer = true;
    });
    $select.setAttribute("data-max", this.props.maxAgeChildUsed);
    if (this.props.maxAgeTeenUsed) {
      if ($select.classList.contains("input-age-teen-JS")) {
        $select.setAttribute("data-min", this.props.maxAgeTeenUsed);
      } else {
        $select.setAttribute("data-max", Number(this.props.maxAgeTeenUsed) - 1);
      }
    }
    this.createForAllSelects($select);

    this.setAgesChilds($select, childAge);

    if (!update || parseInt($select.value) > parseInt(this.props.maxAgeChildUsed)) {
      $select.setAttribute("value", this.props.valueAgeChildUsed);
      $select.value = this.props.valueAgeChildUsed;
    }

    //$select.setAttribute("data-default", this.props.valueAgeChildUsed);

    bcl.u.forEach($select.children, ($option) => {
      const value = parseInt($option.value);
      if (value <= parseInt(this.props.maxAgeChildUsed)) {
        bcl.u.removeClass($option, "hidden");
        if (value === parseInt($select.value)) {
          $option.setAttribute("selected", "selected");
        }
      } else {
        bcl.u.addClass($option, "hidden");
      }
    });
    this.apply(null, null, true);
  },

  setAgesChilds: function ($select, childAge) {
    $select.value = childAge;
    $select.setAttribute("value", childAge);
  },

  processButtonInput: function ($input, newValue, min, max, limitTotal) {
    limitTotal = parseInt(limitTotal);
    const $accordion = $input?.closest(".adults-JS, .teenager-JS, .children-JS")?.parentElement;
    const totalAdults = parseInt($accordion?.querySelector(".input-adult-JS")?.value) ?? 0;
    const totalChildren = parseInt($accordion?.querySelector(".input-child-JS")?.value) ?? 0;
    const totalTeenagers = parseInt($accordion?.querySelector(".input-teenager-JS")?.value) ?? 0;
    const currentTotal = totalAdults + totalChildren + totalTeenagers;

    const reachedLimit = limitTotal === currentTotal;
    this.updatePlusMinusButtons($accordion?.querySelector(".input-adult-JS")?.parentElement, reachedLimit);
    this.updatePlusMinusButtons($accordion?.querySelector("." + this.props.inputTeenagerSelector)?.parentElement, reachedLimit);
    this.updatePlusMinusButtons($accordion?.querySelector(".input-child-JS")?.parentElement, reachedLimit);
  },
  updatePlusMinusButtons: function ($inputContainer, reachedLimit) {
    const $plusBtn = $inputContainer?.children[2];
    const $minusBtn = $inputContainer?.children[0];
    const className = this.props.buttonHiddenClassName;
    const $input = $inputContainer?.querySelector(".input-JS");
    const min = parseInt($input?.min);
    const max = parseInt($input?.max);
    const newValue = parseInt($input?.value);
    if (min === newValue) {
      bcl.u.removeClass($plusBtn, className);
      bcl.u.addClass($minusBtn, className);
    } else if (newValue === max) {
      bcl.u.addClass($plusBtn, className);
      bcl.u.removeClass($minusBtn, className);
    } else {
      bcl.u.removeClass($plusBtn, className);
      bcl.u.removeClass($minusBtn, className);
    }
    if (reachedLimit) {
      bcl.u.addClass($plusBtn, className);
    }
  },

  resetItem: function ($item) {
    const inputs = $item.getElementsByClassName(this.props.inputSelector);

    bcl.u.forEach(inputs, function ($input) {
      bcl.c.fastbooking.rooms.setValueInInput($input, $input.dataset.default);
    });
  },

  setValueInInput: function ($input, value, fromInput) {
    if (!value) {
      value = 0;
    }

    $input.setAttribute("value", value);
    $input.value = value;
    bcl.u.triggerEvent($input, fromInput ? "change" : "changeGuests");
    this.updateAriaLabelBy($input, $input.value);
  },

  removeItem: function ($item, obj, noUpdate) {
    const $parentNode = $item.parentNode;
    $parentNode?.removeChild($item);
    !noUpdate && bcl.c.fastbooking.rooms.updateRooms();
    $parentNode?.querySelector("." + this.props.addSelector)?.focus();
  },

  addItem: function ($container, obj) {
    let $newItem = document.createElement("div");

    $newItem.innerHTML = this.props.template;
    $newItem = $newItem.children[1];

    bcl.c.accordion.closeAll($container);
    $container.children[0].insertBefore($newItem, this.props.$add);
    this.initItem($newItem);

    bcl.c.accordion.init($newItem);

    if (!obj?.noUpdate) {
      this.updateRooms();
    }

    this.setMaxAgeChildSelector($newItem);

    this.updateOccupancyNewRoom($newItem);

    this.resetRegisterData($newItem);

    this.activeTooltip($newItem);

    this.updateInfoOccupancy();
    this.addAriaLabelBy($newItem);
    return $newItem;
  },

  addAriaLabelBy: function ($newItem) {
    if (!$newItem) {
      return;
    }
    const $toggle = $newItem.querySelector(bcl.c?.accordion?.props?.cssSelectorToggle);
    if (!$toggle) {
      return;
    }
    const roomsTitleEl = $newItem.querySelector(".js-rooms-title");
    const roomsAriaPax = $newItem.querySelector(".js-rooms-label-pax");
    const roomsNumber = roomsTitleEl?.querySelector(".room-number-JS")?.innerText;
    if (roomsNumber && roomsAriaPax) {
      roomsAriaPax.innerHTML = "";
      this.buildRoomsAriaPax($newItem, roomsAriaPax, roomsNumber);
      $toggle.setAttribute("aria-labelledby", "room-labelby-pax-" + roomsNumber);
    }
    $toggle.focus();
  },
  buildRoomsAriaPax: function ($newItem, roomsAriaPax, roomsNumber) {
    roomsAriaPax.setAttribute("id", "room-labelby-pax-" + roomsNumber);
    const adultCount = $newItem.querySelector(`.${this.props.adultsNumberSelector}`)?.innerText;
    const childrenCount = $newItem.querySelector(`.${this.props.childrenNumberSelector}`)?.innerText || 0;

    //Build adult and children span
    if (!adultCount) {
      return;
    }
    const roomTileSpan = document.createElement("span");
    roomTileSpan.innerText = `${roomsAriaPax.dataset.titleroomsi18n} ${roomsNumber}, `;

    const adultCountSpan = document.createElement("span");
    adultCountSpan.innerText = `${roomsAriaPax.dataset.adultsi18n} ${adultCount}`;
    bcl.u.addClass(adultCountSpan, "JS-sronly-adultcount");

    const childrenCountSpan = document.createElement("span");
    console.log("REEEE", roomsAriaPax, roomsAriaPax.dataset.childreni18n);
    childrenCountSpan.innerText = `, ${roomsAriaPax.dataset.childreni18n}, ${childrenCount}`;
    bcl.u.addClass(childrenCountSpan, "JS-sronly-childrencount");

    if (adultCount) {
      roomsAriaPax.appendChild(roomTileSpan);
      roomsAriaPax.appendChild(adultCountSpan);

      if (childrenCount == 0) {
        childrenCountSpan.setAttribute("aria-hidden", "true");
      }
      roomsAriaPax.appendChild(childrenCountSpan);
    }
  },
  resetRegisterData: function (container) {
    // CHECK
    if (container) {
      const $adultInputs = container.querySelectorAll("." + this.props.inputAdultSelector);
      const $childInputs = container.querySelectorAll("." + this.props.inputChildSelector);
      $adultInputs?.forEach((el) => {
        if (el.dataset.register) {
          el.dataset.register = "false";
        }
      });
      $childInputs?.forEach((el) => {
        if (el.dataset.register) {
          el.dataset.register = "false";
        }
      });
    }
  },
  activeTooltip: function (container) {
    if (bcl.s.tooltip) {
      const containerTabs = container.getElementsByClassName(bcl.s.tooltip.props.containerTooltipSelector);
      bcl.u.forEach(containerTabs, bcl.s.tooltip.initContainer);
    }
  },

  updateOccupancyNewRoom: function ($node) {
    // CHECK
    this.updateValuesMaxMinOccupancy($node, "adult");
    this.updateValuesMaxMinOccupancy($node, "child");
  },

  updateInfoOccupancy: function () {
    // CHECK
    const nodePax = document.getElementById("numberPax");
    const numberPax = bcl.c.fastbooking.commonProps.destination.data?.data ? parseInt(bcl.c.fastbooking.commonProps.destination.data.data.guestLimitTotal) : this.props.defaultOccupancy;
    nodePax.innerText = numberPax;
    const nodeAdults = document.getElementsByClassName("numberAdults");
    bcl.u.forEach(nodeAdults, this.updateOccupancyAdults.bind(this));
    const nodeChildren = document.getElementsByClassName("numberChildren");
    bcl.u.forEach(nodeChildren, this.updateOccupancyChildren.bind(this));
  },

  updateOccupancyAdults: function (node) {
    const numberAdults = bcl.c.fastbooking.commonProps.destination.data?.data ? parseInt(bcl.c.fastbooking.commonProps.destination.data.data.adultLimit) : this.props.defaultOccupancy;
    node.innerText = numberAdults;
  },

  updateOccupancyChildren: function (node) {
    const numberChildren = bcl.c.fastbooking.commonProps.destination.data?.data ? parseInt(bcl.c.fastbooking.commonProps.destination.data.data.childrenLimit) : this.props.defaultOccupancy;
    node.innerText = numberChildren;
  },

  updateRooms: function () {
    const rooms = this.props.$container.getElementsByClassName(this.props.roomNumberSelector),
      index = rooms.length;

    bcl.u.forEach(rooms, function ($room, i) {
      $room.innerText = i + 1;
    });

    this.updatePag(index);

    if (index < this.props.pagTotal) {
      bcl.u.removeClass(this.props.$add, bcl.c.fastbooking.commonProps.fastbooking.hiddenClass);
    } else {
      bcl.u.addClass(this.props.$add, bcl.c.fastbooking.commonProps.fastbooking.hiddenClass);
    }
  },

  updatePag: function (index) {
    this.props.$pagCount.innerText = index;
    const parentNode = this.props.$pagCount.parentNode;

    if (index > this.props.pagTotal / 2) {
      bcl.u.removeClass(parentNode, bcl.c.fastbooking.commonProps.fastbooking.hiddenClass);
    } else {
      bcl.u.addClass(parentNode, bcl.c.fastbooking.commonProps.fastbooking.hiddenClass);
    }
  },

  apply: function ($node, obj, noClose) {
    const items = this.props.$container.getElementsByClassName(this.props.itemSelector);

    bcl.c.fastbooking.commonProps.rooms.data.rooms = items.length;

    bcl.c.fastbooking.commonProps.rooms.data.adults = [];
    bcl.c.fastbooking.commonProps.rooms.data.children = [];

    let totalPersonsRooms = 0,
      totalAdults = 0,
      totalChildren = 0,
      currentRoomAdults = 0,
      currentChildrenRomm = 0;

    let maxTotal = 0,
      maxAdults = 0,
      maxChildren = 0,
      maxRoomChildrenAges = "";

    bcl.u.forEach(items, ($item) => {
      const $numberRooms = this.searchNode($item, "adultsNumberSelector");
      bcl.c.fastbooking.commonProps.rooms.data.adults.push($numberRooms.innerText);
      currentRoomAdults = 0;
      currentChildrenRomm = 0;

      if ($numberRooms) {
        currentRoomAdults = parseInt($numberRooms.innerText, 10);
      }

      const children = $item.getElementsByClassName(this.props.inputAgeJS),
        childrenData = [];

      bcl.u.forEach(children, ($child) => {
        childrenData.push($child.getAttribute("value"));
        currentChildrenRomm++;
      });

      totalPersonsRooms += currentRoomAdults + currentChildrenRomm;
      totalAdults += currentRoomAdults;
      totalChildren += currentChildrenRomm;

      const currentTotal = currentRoomAdults + currentChildrenRomm;

      if (currentTotal > maxTotal) {
        maxTotal = currentTotal;
        maxAdults = currentRoomAdults;
        maxChildren = currentChildrenRomm;
        maxRoomChildrenAges = childrenData.join(",");
      }

      bcl.c.fastbooking.commonProps.rooms.data.children.push(childrenData);
    });

    bcl.c.fastbooking.commonProps.rooms.totalAdults = totalAdults;
    bcl.c.fastbooking.commonProps.rooms.totalChildren = totalChildren;

    bcl.c.fastbooking.commonProps.rooms.valueAdults = maxAdults;
    bcl.c.fastbooking.commonProps.rooms.valueChildren = maxChildren;
    bcl.c.fastbooking.commonProps.rooms.maxRoomChildrenAges = maxRoomChildrenAges;

    this.applyRooms();
    this.applyAdultsOrChildren(totalPersonsRooms, "adultsNumberSelector");

    bcl.s.tabs.cleanAndSetStylePopFbDialog(this.props.$container);

    if (noClose) {
      return;
    }

    if (!this.props.used) {
      bcl.s.tabs.openNext();
      this.props.used = true;
    } else {
      bcl.s.tabs.closeActive();
    }
  },

  applyRooms: function () {
    const $node = this.searchNode(this.props.$rooms, "roomNumberSelector");
    $node.innerText = bcl.c.fastbooking.commonProps.rooms.data.rooms;
  },

  applyAdultsOrChildren: function (value, selector) {
    const $node = this.searchNode(this.props.$rooms, selector);

    $node.innerText = value;

    if (value > 0) {
      bcl.u.removeClass($node.parentNode, bcl.c.fastbooking.commonProps.fastbooking.hiddenClass);
    } else {
      bcl.u.addClass($node.parentNode, bcl.c.fastbooking.commonProps.fastbooking.hiddenClass);
    }
  },

  updateDataDest: function (data) {
    if (!this.props.maxAgeChildDefault) {
      this.copyHTML();
    }
    const maxOld = this.props.maxAgeChildUsed;
    this.props.adultsOnly = false;

    this.props.maxAgeChildUsed = this.props.maxAgeChildDefault;
    this.props.valueAgeChildUsed = this.props.valueAgeChildDefault;

    bcl.u.removeClass(this.props.$container, this.props.hiddenChildrenClass);

    let setZeroChild;

    if (data?.data && data.type !== "group") {
      this.props.maxAgeChildUsed = data.data.minAdultsAge;
      if (data.data.minTeenagersAge && data.data.minTeenagersAge > 0) {
        this.props.maxAgeTeenUsed = data.data.minTeenagersAge;
      }

      if (this.props.valueAgeChildUsed > data.data.minAdultsAge) {
        this.props.valueAgeChildUsed = data.data.minAdultsAge;
      }

      if (data.data.adultsOnly === true || data.data.adultsOnly === "true") {
        this.props.adultsOnly = true;
        bcl.u.addClass(this.props.$container, this.props.hiddenChildrenClass);
        setZeroChild = true;
      }

      if (data.data.minTeenagersAge && data.data.minTeenagersAge > 0) {
        this.props.minAgeTeenagersUsed = data.data.minTeenagersAge;
        bcl.u.removeClass(this.props.$container, this.props.hiddenTeenagersClass);
      } else {
        this.props.minAgeTeenagersUsed = null;
        bcl.u.addClass(this.props.$container, this.props.hiddenTeenagersClass);
      }
    }

    this.setMaxAgeChildSelector();
    this.setMinAgeTeenagerSelector();

    if (setZeroChild || maxOld > this.props.maxAgeChildUsed) {
      const inputs = this.props.$container.getElementsByClassName(this.props.inputChildSelector);

      bcl.u.forEach(inputs, ($input) => {
        this.setValueInInput($input, 0);
      });
    }

    //Get All rooms on fasbooking divs and put all childs numbers on each room
    const roomsSelected = document.querySelectorAll("." + this.props.cfastbookingSubmenuRoomsRoomRoomNumberJS);
    if (roomsSelected) {
      if (bcl.cookie.get(this.props.cookieName) && bcl.cookie.get(this.props.cookieName) != "") {
        const roomsJsonObject = JSON.parse(bcl.cookie.get(this.props.cookieName));
        if (roomsJsonObject) {
          bcl.u.forEach(roomsSelected, ($roomOnFastBooking, indexRoom) => {
            const inputsAgeSelects = $roomOnFastBooking.parentNode.parentNode.parentNode.querySelectorAll("." + this.props.inputAgeJS);
            if (inputsAgeSelects) {
              bcl.u.forEach(inputsAgeSelects, ($selectChildItem, indexChildItem) => {
                if (roomsJsonObject.children && roomsJsonObject.children.length > 0) {
                  const ageChild = roomsJsonObject.children[indexRoom][indexChildItem];
                  this.updateOptionsSelectChildAges($selectChildItem, true, indexChildItem, ageChild);
                }
              });
            }
          });
        }
      }
    }
    //End Get All rooms on fasbooking divs and put all childs numbers on each room
    this.apply(null, null, true);
  },
  setMaxAgeChildSelector: function ($node) {
    if (!$node) {
      if (!this.props.$container) {
        const $container = bcl.c.fastbooking.commonProps.fastbooking.$container.getElementsByClassName(this.props.cssSelector);
        if (!$container?.[0]) {
          return;
        }
        this.props.$container = $container[0];
      }
      $node = this.props.$container;
    }

    const maxAge = this.props.minAgeTeenagersUsed && this.props.minAgeTeenagersUsed > 0 ? this.props.minAgeTeenagersUsed : this.props.maxAgeChildUsed;

    const $elements = $node.getElementsByClassName(this.props.maxAgeChildSelector);

    bcl.u.forEach($elements, ($element) => {
      if (this.props.minAgeTeenagersUsed && this.props.minAgeTeenagersUsed > 0) {
        $element.innerText = Number(maxAge) - 1;
        const upToNode = $node.querySelector(".upto-age-child-JS");
        if (upToNode) {
          upToNode.classList.add("hidden");
          const fromNode = $node.querySelector(".from-age-child-JS");
          fromNode.classList.remove("hidden");
        }
      } else {
        $element.innerText = maxAge;
      }
    });

    const tooltipIconInfo = document.querySelector("." + this.props.maxAgeChildSelectorIcoInfo);
    if (tooltipIconInfo) {
      tooltipIconInfo.innerText = maxAge;
    }

    // Adjust text tooltip if teenager age is used
    const tooltipInfoTeenager = document.querySelector("." + this.props.maxAgeChildSelectorTeenagerPriceInfo);
    const tooltipInfoAdult = document.querySelector("." + this.props.maxAgeChildSelectorAdultPriceInfo);
    if (this.props.minAgeTeenagersUsed && this.props.minAgeTeenagersUsed > 0) {
      bcl.u.removeClass(tooltipInfoTeenager, "hidden");
      bcl.u.addClass(tooltipInfoAdult, "hidden");
    } else {
      bcl.u.removeClass(tooltipInfoAdult, "hidden");
      bcl.u.addClass(tooltipInfoTeenager, "hidden");
    }
  },

  setMinAgeTeenagerSelector: function ($node) {
    if (!$node) {
      if (!this.props.$container) {
        const $container = bcl.c.fastbooking.commonProps.fastbooking.$container.getElementsByClassName(this.props.cssSelector);
        if (!$container?.[0]) {
          return;
        }
        this.props.$container = $container[0];
      }
      $node = this.props.$container;
    }

    // Min age for teenagers
    let $elements = $node.getElementsByClassName(this.props.minAgeTeenagerSelector);

    bcl.u.forEach($elements, ($element) => {
      $element.innerText = this.props.minAgeTeenagersUsed;
    });

    // Max age for teenagers
    $elements = $node.getElementsByClassName(this.props.maxAgeTeenagerSelector);

    bcl.u.forEach($elements, ($element) => {
      $element.innerText = this.props.maxAgeChildUsed;
    });

    const tooltipIconInfo = document.querySelector("." + this.props.minAgeTeenagerSelectorIcoInfo);
    if (tooltipIconInfo) {
      tooltipIconInfo.innerText = Number(this.props.maxAgeChildUsed) + 1;
    }
  },

  generateData: function (obj) {
    const adults = bcl.c.fastbooking.commonProps.rooms.data.adults,
      children = bcl.c.fastbooking.commonProps.rooms.data.children;

    obj.rooms = adults.length;
    obj.adult = this.generateString(adults, "|");

    let childrenResult = "",
      childrenAgeResult = "",
      isChildren = false;

    for (let i = 0; i < children.length; i++) {
      childrenResult += children[i].length;

      if (children[i].length) {
        isChildren = true;
        childrenAgeResult += this.generateString(children[i], "|");
      } else {
        childrenAgeResult += "";
      }

      if (i !== adults.length - 1) {
        childrenResult += "|";
        childrenAgeResult += ",";
      }
    }

    if (isChildren) {
      obj.child = childrenResult;
      obj.childages = childrenAgeResult;
    }

    return obj;
  },

  generateString: function (array, separator) {
    let result = "";

    for (let i = 0; i < array.length; i++) {
      result += array[i];

      if (i !== array.length - 1) {
        result += separator;
      }
    }

    return result;
  },

  updateData: function (obj) {
    this.updateDataRooms(obj);
    this.updateDataAdults(obj);
    this.updateDataChildren(obj);
    this.apply(null, null, true);
  },

  updateDataRooms: function (obj) {
    let roomsCount = this.props.$container.getElementsByClassName("c-fastbooking__submenu-rooms-room").length,
      roomsCountNew = obj.adults.length;

    if (roomsCount < roomsCountNew) {
      for (let i = 0; i < roomsCountNew - roomsCount; i++) {
        this.addItem(this.props.$container, { noUpdate: true });
      }

      this.updateRooms();
      this.setMaxAgeChildSelector();
    } else if (roomsCount > roomsCountNew) {
      const $container = this.props.$container.children[0];

      roomsCountNew--;
      roomsCount--;

      for (let n = roomsCount; n > roomsCountNew; n--) {
        this.removeItem($container.children[n], {}, true);
      }

      this.updateRooms();
    }
  },

  updateDataAdults: function (obj) {
    const inputs = this.props.$container.getElementsByClassName(this.props.inputAdultSelector);

    bcl.u.forEach(inputs, ($input, index) => {
      this.setValueInInput($input, obj.adults[index]);
    });
  },

  updateDataChildren: function (obj) {
    if (this.props.adultsOnly) {
      return;
    }

    const inputs = this.props.$container.getElementsByClassName(this.props.inputChildSelector);

    bcl.u.forEach(inputs, ($input, index) => {
      const child = obj.children[index];
      if (child instanceof Array && child?.length == 0) {
        return;
      }
      if (child) {
        this.setValueInInput($input, child.length);

        const parent = $input.closest("." + this.props.itemSelector),
          inputsAge = parent.getElementsByClassName(this.props.inputAgeJS);

        bcl.u.forEach(inputsAge, function ($inputAge, index) {
          const $option = $inputAge.querySelector('[value="' + child[index] + '"]'),
            $optionSelected = $inputAge.querySelector('[value="' + $inputAge.value + '"]');

          if ($optionSelected) {
            $optionSelected.removeAttribute("selected");
          }

          if ($option) {
            $inputAge.setAttribute("value", child[index]);
            $inputAge.value = child[index];
            $option.setAttribute("selected", "selected");
          }
        });
      }
    });
  },

  updateValuesMaxMinOccupancy: function (node, type) {
    if (bcl.c.fastbooking.commonProps.destination.data?.data) {
      const typeSelector = { child: "childrenLimit", adult: "adultLimit", guest: "guestLimitTotal" }[type];
      let limit = bcl.c.fastbooking.commonProps.destination.data.data[typeSelector];
      if (limit === undefined) {
        limit = 0;
      }
      const regexp = new RegExp('"' + typeSelector + '":\\d+', "g");
      if (!limit && bcl.c.fastbooking.commonProps.destination.data.groupItems) {
        const matchedLimits = JSON.stringify(bcl.c.fastbooking.commonProps.destination.data.groupItems).match(regexp);

        if (matchedLimits) {
          bcl.u.forEach(matchedLimits, (match) => {
            let currentNumber = match.match(/\d+$/);
            if (currentNumber) {
              currentNumber = parseInt(currentNumber[0]);
              limit = limit < currentNumber ? currentNumber : limit;
            }
          });
        }
      }

      if (typeof limit === "string") {
        limit = parseInt(limit);
      }
      limit = limit || bcl.c.fastbooking.rooms.props.defaultOccupancy;
      bcl.c.fastbooking.commonProps.destination.data.data[typeSelector] = limit;
      const numChildMin = type === "child" ? bcl.c.fastbooking.rooms.props.defaultMinAdults : 0;
      if (type !== "guest") {
        const inputElements = node.getElementsByClassName(bcl.c.fastbooking.rooms.props[type === "adult" ? "inputAdultSelector" : "inputChildSelector"]);
        if (inputElements) {
          bcl.u.forEach(inputElements, ($input) => {
            if ($input.getAttribute("max") && $input.getAttribute("min")) {
              $input.setAttribute("max", limit);
              $input.setAttribute("min", this.props.defaultMinAdults - numChildMin);
            }
          });
        }
        if (this.props.minAgeTeenagersUsed) {
          const inputTeenElements = node.getElementsByClassName(bcl.c.fastbooking.rooms.props["inputTeenagerSelector"]);
          if (inputTeenElements) {
            bcl.u.forEach(inputTeenElements, ($input) => {
              if ($input.getAttribute("max") && $input.getAttribute("min")) {
                $input.setAttribute("max", limit);
                $input.setAttribute("min", this.props.defaultMinAdults - numChildMin);
              }
            });
          }
        }
      }
    }
  },

  getInitCookies: function () {
    let rooms = bcl.cookie.get(this.props.cookieName);

    if (!rooms) {
      return;
    }

    rooms = JSON.parse(rooms);

    if (!rooms) {
      return;
    }

    this.updateData(rooms);
  },

  addCookies: function () {
    const data = {};

    this.generateData(data);

    const obj = {
      adults: bcl.c.fastbooking.commonProps.rooms.data.adults,
      children: bcl.c.fastbooking.commonProps.rooms.data.children,
      adultsCount: data.adult,
      childrenCount: data.child,
    };

    if (Object.keys(obj).length === 0) {
      return;
    }

    bcl.c.fastbooking.setCookies(this.props.cookieName, JSON.stringify(obj));
  },

  closeTab: function () {
    bcl.s.tabs.toggleClassActive(this.props.$rooms, false);
    this.apply(null, null, true);
  },

  openTab: function () {
    bcl.s.tabs.toggleClassActive(this.props.$rooms, true);
  },
};

export default rooms;
